import React from "react";
import { useNavigate } from "react-router";

const ManagePricingStrategy = ({ selectedItem }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{ background: "#fafafa", padding: "20px" }}
      className="d-flex flex-column gap-15 overflow-y-auto align-items-center text-center"
    >
      <div
        style={{
          backgroundColor: "#EFF6FF",
          border: "1px solid #BFDBFE",
          borderRadius: "8px",
          padding: "16px",
          width: "100%",
        }}
      >
        <h5 style={{ color: "#1D4ED8", fontWeight: "700", marginBottom: "8px" }}>
          Pricing Strategy Moved
        </h5>
        <p style={{ color: "#1E40AF", fontSize: "13px", margin: 0 }}>
          Pricing strategy and coupon updates are disabled from this drawer. Please manage weekly pricing schedules and coupon configurations in the Vendor Promo Scheduler.
        </p>
      </div>

      <button
        type="button"
        className="btn btn-primary font-weight-bold px-4 py-2 mt-2"
        style={{ width: "100%", borderRadius: "6px" }}
        onClick={() => navigate("/admin/vendor-coupons")}
      >
        Go to Vendor Promo Scheduler
      </button>
    </div>
  );
};

export default ManagePricingStrategy;
